var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ローディング
import {loading} from "../include/module";
loading();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

//外部ページからのアンカー
import {externalAnchor} from "../include/module";
externalAnchor();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// アニメーション
import {animationFire} from "../include/module";
animationFire();

// ページ下部のキャラランダム表示
import {bottomCharaRandom} from "../include/module";
bottomCharaRandom();

//スライダー
const slider = () => {
  $('.js-Slider').each(function(){
    $(this).slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
    });
  });
};
$(document).ready(function(){
  // slider
  if (windowWidth > breakPoint) {
  } else {
    slider();
  }
  var timer = false;
  $(window).on('resize',function() {
    var resizeWidth = $(window).width();
    clearTimeout(timer);
    timer = setTimeout(function() {
      if(windowWidth != resizeWidth){
        if(resizeWidth > breakPoint){
          $('.js-Slider').slick('unslick');
        } else {
          slider();
        }
      }
      windowWidth = resizeWidth;
    }, 100);
  });
});


// WEBPACK FOOTER //
// script.js